import React, { useState } from 'react';
import { Button, Divider } from 'semantic-ui-react';

import { Typography } from 'src/components/coreUI/index';
import { formatPrice, getExpiredDate } from 'src/utils/helper';
import { createPaymentIntent } from 'src/thunks/payment';
import { useAppDispatch, useAppSelector } from 'src/store';
import { PATH } from 'src/constants/app';
import dayjs from 'dayjs';

type Props = Model.ClassUserStatus;

const ExtensionForm: React.FC<Props> = ({
  class: course,
  id: class_user_id,
  expired_at,
  ...rest
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const user_id = useAppSelector((state) => state.ui.app.me?.id);
  const dispatch = useAppDispatch();

  const extensionPrices = course?.prices?.filter((p) => p.is_extension) || [];

  const [price, setPrice] = useState<Model.Price | undefined>(
    extensionPrices[0],
  );

  // If today is before expired_at, then paid_at is expired_at, else paid_at is today
  const { expired_date } = getExpiredDate({
    class: course as Model.Class,
    class_price_id: price?.id,
    paid_at: dayjs().isBefore(dayjs(expired_at))
      ? expired_at
      : dayjs().toString(),
  });

  // const [validCoupon, setValidCoupon] = useState<ValidCoupon>();

  return (
    <div className="p-12">
      <h3>Select package</h3>

      <div className="radio pricing">
        {extensionPrices.map((p) => {
          return (
            <div
              key={p.id}
              className={`item ${p.id === price?.id ? 'active' : ''}`}
              onClick={() => {
                setPrice(p);
                // setValidCoupon(undefined);
              }}
            >
              <div className="price">{formatPrice(p.price)}</div>
              <div>{p.limit_months} MONTHS ACCESS</div>
            </div>
          );
        })}
      </div>

      <div className="text-gray mt-24">
        Course will be available for {price?.limit_months} months, until{' '}
        {/*{dayjs().add(price?.limit_months!, 'month').format(FULL_MONTH)}*/}
        {expired_date}
      </div>

      {/*{!isFree && (*/}
      {/*  <CouponForm*/}
      {/*    validCoupon={validCoupon}*/}
      {/*    price={price}*/}
      {/*    onSuccess={setValidCoupon}*/}
      {/*  />*/}
      {/*)}*/}

      <Divider />
      <Typography.Paragraph className="d-flex-between">
        Total (1 item) {/*<span className="fs-24 fw-bold text-primary">*/}
        {/*  {!validCoupon && formatPrice(price?.price)}*/}
        {/*  {!!validCoupon &&*/}
        {/*    price?.price &&*/}
        {/*    formatPrice(price.price - validCoupon.discount_amount)}*/}
        {/*</span>*/}
      </Typography.Paragraph>

      <Button
        primary
        fluid
        loading={loading}
        disabled={!price}
        onClick={async () => {
          setLoading(true);
          await dispatch(
            createPaymentIntent({
              user_id,
              class_id: course?.id,
              class_price_id: price?.id,
              // coupon: validCoupon?.id,
              redirect: PATH.PAYMENT_EXTENSION,
              parent_id: class_user_id,
              expired_date,
            }),
          );
        }}
      >
        Next
      </Button>
    </div>
  );
};

// type CouponFormProps = {
//   price?: Model.Price;
//   onSuccess?: (value: ValidCoupon | undefined) => void;
//   validCoupon?: ValidCoupon;
// };

// const CouponForm: React.FC<CouponFormProps> = ({
//   price,
//   validCoupon,
//   onSuccess,
// }) => {
//   const dispatch = useAppDispatch();
//   const { getFieldInfo, submitForm, isSubmitting, values } =
//     useForm<ValidateCouponCode>({
//       initialValues: {
//         class_price_id: price?.id,
//         coupon_code: '',
//       },
//       async onSubmit(value) {
//         const res = await dispatch(validateCouponCode(value));
//
//         if (validateCouponCode.fulfilled.match(res)) {
//           const coupon = res.payload as unknown as ValidCoupon;
//           onSuccess?.(coupon);
//         }
//       },
//       enableReinitialize: true,
//       validationSchema: Yup.object().shape({
//         coupon_code: Yup.string().max(255).label('Coupon'),
//       }),
//     });
//
//   return (
//     <React.Fragment>
//       <Divider />
//       <Form>
//         <div className="d-flex-between my-12">
//           <span className="fs-16">Coupon (1 item)</span>
//           <span className="fs-18 fw-bold text-primary">
//             {validCoupon && validCoupon.amount_off
//               ? formatPrice(validCoupon.discount_amount)
//               : null}
//             {validCoupon && validCoupon.percent_off
//               ? `${validCoupon.percent_off}%`
//               : null}
//           </span>
//         </div>
//
//         <Form.Group unstackable className="coupon">
//           <Form.Input
//             disabled={!!validCoupon}
//             placeholder="Coupon code"
//             className="w-100"
//             {...getFieldInfo('coupon_code')}
//           />
//
//           {validCoupon && (
//             <span className="clear" onClick={() => onSuccess?.(undefined)}>
//               &#x2715;
//             </span>
//           )}
//
//           {validCoupon ? (
//             <div className="applied">Applied!</div>
//           ) : (
//             <Button
//               basic
//               color="purple"
//               className="mr-8"
//               disabled={!values.coupon_code}
//               loading={isSubmitting}
//               onClick={submitForm}
//             >
//               Apply
//             </Button>
//           )}
//         </Form.Group>
//       </Form>
//     </React.Fragment>
//   );
// };

export default ExtensionForm;
